<template>
  <div class="login2">
    <div class="login2-card">
      <div class="login-form login2-form" @keydown.enter="onSubmit">
        <div class="login-form__title">
          <div style="display: flex;align-items: center;justify-content: center">
            <svgicon name="Logo-squares"></svgicon>
            <svgicon name="Video_Analytics" class="svg-text"></svgicon>
          </div>
          <!--<span>Video analytics</span>-->
          <div class="login-form__subtitle acr-regular">
            App for collecting and analysing sport videos <br>
            using Machine Learning algorithm
          </div>
        </div>
        <div class="login-form__data">
          <div class="login-form__field">
            <div class="login-form__label acr-bold-18">E-mail</div>
            <input type="text" class="login-form__input"  v-model="username" placeholder="yourname@company.com">
          </div>
          <div class="login-form__field">
            <div class="login-form__label acr-bold-18">Password</div>
            <input type="password" class="login-form__input" v-model="password" placeholder="xxxxxxxxxxxxxxxxx">
          </div>
          <div class="login-form__field">
            <div class="login-form__btn" @click="onSubmit">
              <span class="acr-bold-18" style="margin-top: -2px">Get started</span>
              <svgicon name="Arrow-right"></svgicon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'

  export default {
    name: 'Login',
    data() {
      return {
        loading: false,
        username: '',
        password: '',
        invalidUsername: false,
        invalidPw: false,
      };
    },
    methods: {
      ...mapActions({
        login: 'login',
        success: 'success',
        error: 'error',
      }),
      onSubmit() {
        this.loading = true;

        if (!this.username || !this.password) {
          this.loading = false;

          if (!this.username) {
            this.invalidUsername = true;
          }

          if (!this.password) {
            this.invalidPw = true;
          }

          return this.error('Validation error');
        }

        let formD = new FormData();
        formD.append('username', this.username);
        formD.append('password', this.password);
        this.login(formD).then(() => {
          this.$store.dispatch('fetchProjectTypes');
          this.$store.dispatch('fetchAllBrandDetectionModels');
        }).catch(() => {
          this.loading = false;
        })
      },
    },
  };
</script>


<style lang="scss">

</style>
